import { useState, useEffect } from 'react';

const TRANSITION_MS = 1500;

const SCRIM =
  'linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.2) 30%, rgba(0,0,0,0) 80%, rgba(0,0,0,0.6) 100%)';

function BackgroundSlideshow({ images, fadeTime = 20 }) {
  const [state, setState] = useState({ current: 0, next: 1, fading: false });

  useEffect(() => {
    setState({ current: 0, next: 1, fading: false });
  }, [images]);

  useEffect(() => {
    if (images.length < 2) return;
    const slideMs = fadeTime * 1000;
    const interval = setInterval(() => {
      setState((prev) => ({ ...prev, fading: true }));
      setTimeout(() => {
        setState((prev) => ({
          current: (prev.current + 1) % images.length,
          next: (prev.next + 1) % images.length,
          fading: false,
        }));
      }, TRANSITION_MS);
    }, slideMs);
    return () => clearInterval(interval);
  }, [images, fadeTime]);

  return (
    <div className="absolute inset-0">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${images[state.current]})` }}
      />
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${images[state.next]})`,
          opacity: state.fading ? 1 : 0,
          transition: state.fading ? `opacity ${TRANSITION_MS}ms ease-in-out` : 'none',
        }}
      />
      <div className="absolute inset-0" style={{ background: SCRIM }} />
    </div>
  );
}

export default BackgroundSlideshow;
